import React, { useEffect } from 'react';
import {
  Container,
  Description,
  HeroSection,
  Title,
  Subtitle,
  ImageSection,
  MainImage,
  ButtonWrapper,
  CTAButton,
} from './styled';

import FactoryImage from '../../assets/FactoryHome.jpeg';
import DoubleCurveSection from './DoubleCurveSection/DoubleCurveSection';
import ContactForm from './Form/Form';
import { useLocation } from 'react-router-dom';

const HomePage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTarget = params.get('scroll');

    if (scrollTarget === 'contact') {
      handleScrollToSection()
    }
  }, [location]);

  
  const handleScrollToSection = () => {
    const section = document.getElementById('contact');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Container>
      <HeroSection>
        <Title>Telma MicroNeedles</Title>
        <Subtitle>Setting new benchmarks in surgical innovation</Subtitle>
        <Description>
          Atraumatic needles, surgical sutures, and polypropylene mesh designed for precision and reliability.
        </Description>
        <DoubleCurveSection />

        <ButtonWrapper>
            <CTAButton onClick={handleScrollToSection}>Get In Touch</CTAButton>
        </ButtonWrapper>
        <ImageSection>
          <MainImage src={FactoryImage} alt="Factory Image" />
        </ImageSection>
      </HeroSection>

      {/* <ZigZagSection /> */}

        <ContactForm />
        
    </Container>
  );
};

export default HomePage;
